import Link from 'next/link'
import Head from 'next/head'
import { useRouter } from 'next/router'

import { getCategorieBySlug } from '../../../lib/api'

import Navbar from 'components/navbar'
import Layout from 'components/layout'
import Articlecard from 'components/article/card'
import Footer from 'components/footer'

export default function categories({ categorie }) {
  const router = useRouter()

  if (router.isFallback) {
    return <div>Loading...</div>
  }

  return (
    <>
      <Head>
        <meta charSet="utf-8" />

        <meta name="robots" content={`${categorie.seo.metaRobotsNoindex}, ${categorie.seo.metaRobotsNofollow}`} />

        <title>{categorie.seo.title}</title>
        <meta name="title" content={categorie.seo.title} />
        <meta name="description" content={categorie.seo.metaDesc} />
        <link rel="canonical" href={`${process.env.NEXT_PUBLIC_BASEPATH}/blog/categorie/${categorie.slug}`} />

        {/* Open graph (FB) */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content={`${process.env.NEXT_PUBLIC_BASEPATH}/blog/categorie/${categorie.slug}`} />
        {categorie.seo.opengraphTitle ? (
          <meta property="og:title" content={categorie.seo.opengraphTitle} />
        ) : (
          <meta property="og:title" content={categorie.seo.title} />
        )}
        {categorie.seo.opengraphDescription ? (
          <meta property="og:description" content={categorie.seo.opengraphDescription} />
        ) : (
          <meta property="og:description" content={categorie.seo.metaDesc} />
        )}
        {categorie.seo.opengraphImage && (
          <>
            <meta property="og:image" content={categorie.seo.opengraphImage.sourceUrl} />
            <meta property="og:image:alt" content={categorie.seo.opengraphImage.altText} />
            <meta property="og:image:width" content={categorie.seo.opengraphImage.mediaDetails.width} />
            <meta property="og:image:height" content={categorie.seo.opengraphImage.mediaDetails.height} />
          </>
        )}

        {/* Twitter */}
        <meta property="twitter:card" content="summary_large_image" />
        <meta property="twitter:url" content={`${process.env.NEXT_PUBLIC_BASEPATH}/blog/categorie/${categorie.slug}`} />

        {categorie.seo.twitterTitle ? (
          <meta property="twitter:title" content={categorie.seo.twitterTitle} />
        ) : (
          <meta property="twitter:title" content={categorie.seo.title} />
        )}
        {categorie.seo.twitterTitle ? (
          <meta property="twitter:description" content={categorie.seo.twitterDescription} />
        ) : (
          <meta property="twitter:description" content={categorie.seo.metaDesc} />
        )}
        {categorie.seo.twitterImage?.mediaDetails && (
          <>
            <meta property="twitter:image" content={categorie.seo.twitterImage.sourceUrl} />
            <meta property="twitter:image:alt" content={categorie.seo.twitterImage.altText} />
            <meta property="twitter:image:width" content={categorie.seo.twitterImage.mediaDetails.width} />
            <meta property="twitter:image:height" content={categorie.seo.twitterImage.mediaDetails.height} />
          </>
        )}

        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              '@context': 'https://schema.org',
              '@type': 'WebPage',
              author: {
                '@id': 'https://ateliermilky.com#identity'
              },
              publisher: {
                '@id': 'https://ateliermilky.com#identity'
              },
              headline: categorie.seo.title,
              name: categorie.seo.title,
              mainEntityOfPage: `${process.env.NEXT_PUBLIC_BASEPATH}/blog/categorie/${categorie.slug}`
            })
          }}
        />
      </Head>
      <Navbar />
      <main className="mt-12">
        <Layout>
          <h1 className="font-serif text-5xl font-medium text-yellow md:text-6xl">{categorie.name}</h1>
          <Link href="/blog/categorie">
            <a className="text-sm uppercase tracking-wider text-gray-600">⟵ Toutes les catégories</a>
          </Link>

          {categorie.description && (
            <div className="mt-8">
              <p className="text-lg leading-tight" dangerouslySetInnerHTML={{ __html: categorie.description }} />
            </div>
          )}

          <div className="mt-16 grid grid-cols-1 gap-4 md:grid-cols-3">
            {categorie.posts.nodes.map((thisArticle) => (
              <Articlecard
                key={thisArticle.id}
                slug={thisArticle.slug}
                featuredImage={thisArticle.featuredImage}
                title={thisArticle.title}
                excerpt={thisArticle.excerpt}
              />
            ))}
          </div>
        </Layout>
      </main>
      <div className="mt-32">
        <Footer />
      </div>
    </>
  )
}

export async function getStaticProps({ params }) {
  const categorie = await getCategorieBySlug(params.slug)

  if (!categorie) return { notFound: true }

  return {
    props: { categorie },
    revalidate: 300 // 5 min
  }
}

export async function getStaticPaths() {
  return {
    paths: [],
    fallback: true
  }
}
